/**
 * Builds the query string for the Offer History deep link.
 *
 * @param {string|number|null|undefined} jobId - Licensing job id
 * @param {string|number|null|undefined} offerId - Offer table row id
 * @param {number} [page] - Optional page number to return to in Offers table
 * @returns {string} Query string starting with `?`, or empty string if either id is missing
 */
export function buildOfferHistorySearch(jobId, offerId, page) {
  if (jobId == null || jobId === "" || offerId == null || offerId === "") {
    return "";
  }
  const paramsObj = {
    jobId: String(jobId),
    offerId: String(offerId),
  };

  // Include page parameter if provided and valid (convert 0-based to 1-based)
  if (page !== undefined && page !== null && !isNaN(page)) {
    paramsObj.page = String(page + 1);
  }

  const params = new URLSearchParams(paramsObj);
  return `?${params.toString()}`;
}

/**
 * Full client path for Offer History (pathname + query).
 *
 * @param {string|number|null|undefined} jobId - Licensing job id
 * @param {string|number|null|undefined} offerId - Offer table row id
 * @param {number} [page] - Optional page number to return to in Offers table
 * @returns {string|null} `/offerHistory?...` or null if ids are incomplete
 */
export function buildOfferHistoryHref(jobId, offerId, page) {
  const search = buildOfferHistorySearch(jobId, offerId, page);
  if (!search) return null;
  return `/offerHistory${search}`;
}

/**
 * Builds the Offers page URL to return to from Offer History.
 *
 * @param {string|number|null|undefined} jobId - Licensing job id
 * @param {number|string|null|undefined} [page] - 1-based page number from Offer History URL
 * @returns {string|null} `/offers?...` or null if jobId is missing
 */
export function buildOffersReturnHref(jobId, page) {
  if (jobId == null || jobId === "") {
    return null;
  }

  const params = new URLSearchParams({ jobId: String(jobId) });

  if (page !== undefined && page !== null && page !== "") {
    params.set("page", String(page));
  }

  return `/offers?${params.toString()}`;
}
